exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.drawer-footer[data-v-62423b5a] {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  padding: 16px 24px;\n  background: #fff;\n  border-top: 1px solid #f0f0f0;\n  text-align: right;\n  z-index: 10;\n}\n.upload-form[data-v-62423b5a] {\n  max-height: 90vh;\n  overflow-y: auto;\n  padding-bottom: 80px;\n}\n.dialog-form[data-v-62423b5a] {\n  max-height: 70vh;\n  overflow-y: auto;\n  padding-bottom: 40px;\n}\n.upload-tip[data-v-62423b5a] {\n  color: #999;\n  font-size: 12px;\n  margin-top: 4px;\n  margin-left: 2px;\n}\n", ""]);

// exports
